var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.products),function(product){return _c('div',{key:product.id},[_c('form-product',{attrs:{"product":product},on:{"deleteFormProduct":_vm.deleteProductForm,"handleInput":_vm.handleInputValue}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }